import { render, staticRenderFns } from "./FormWizard.vue?vue&type=template&id=9311c11e&"
import script from "./FormWizard.ts?vue&type=script&lang=ts&"
export * from "./FormWizard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports